import React from 'react'
import { useUserRegion } from '@/services/UserRegionService'
import { ReactFCC } from '@/types/react'

interface RegionContextProp {
  children: React.ReactNode
}

interface RegionContextType {
  region: string | undefined
  loading: boolean
}

const RegionContext = React.createContext<RegionContextType>({
  region: undefined,
  loading: true,
})

export const RegionContextProvider: ReactFCC<RegionContextProp> = ({ children }) => {
  const value = useUserRegion()

  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>
}

export function useRegionContext() {
  return React.useContext(RegionContext)
}
